<template>
  <div class="price serif">
    <div
      class="flex bottom-xs wrap mt20 special-price end-sm alternative"
      v-if="product.promo_price && originalPrice"
    >
      <div class="row price">
        <p class=" cl-black weight-900 m0">
          {{ $t('Subscription') }}
        </p>
        <div class="h3 lh20 cl-burnt-sienna weight-700 word-nowrap ">
          {{ product.promo_price | price(storeView) }}
          <small class="fs16">/ {{ $t('piece') }}</small>
          <span class="price-original cl-light-gray weight-500 fs16">
            {{ originalPrice | price(storeView) }}
          </span>
        </div>
      </div>
      <div class="row info">
        <p class="fs-medium-small cl-black m0 align-left">
          Za {{ subscribtionPeriod }}. Potem {{ specialPrice | price(storeView) }}
        </p>
        <p class="h5 cl-burnt-sienna m0">
          {{ saleDifferenceAlternative }}
        </p>
      </div>
    </div>
    <div
      class="flex bottom-xs wrap special-price end-sm"
      v-else-if="(initialPrice.special && price.default && price.original) || bundleSpecialMinPrice"
    >
      <div
        class="h3 lh20 weight-700 word-nowrap"
        :class="{ 'cl-burnt-sienna' : omnibusPrice && saleDifference }"
      >
        {{ specialPrice | price(storeView) }}
        <small class="h4">/ {{ $t('piece') }}</small>
        <span v-show="omnibusPrice && saleDifference" class="price-original cl-light-gray weight-500 h5 pl10">
          {{ omnibusPrice | price(storeView) }}
        </span>
      </div>
      <div class="h5 pt5 cl-burnt-sienna w-100">
        {{ saleDifference }}
      </div>
      <div v-show="omnibusPrice && saleDifference" class="price-history h5 pt10 cl-black w-100">
        <p class="m0">
          {{ $t(`Najniższa cena w ostatnich 30 dniach: ${omnibusPrice} zł`) }}
        </p>
      </div>
    </div>
    <div
      class="h3 cl-black weight-500 align-right"
      v-else
    >
      {{ price.default | price(storeView) }}
      <small class="h4">/ {{ $t('piece') }}</small>
    </div>
    <div class="price-history h5 pb10 cl-black mt10 w-100">
      <p class="cl-main mt0 mb10 end-sm">
        {{ retailPromoText }}
      </p>
      <p v-show="omnibusPrice && saleDifference" class="open-omni-chart m0 text-underline end-sm">
        {{ $t(`Zobacz historię ceny`) }}
      </p>
    </div>
  </div>
</template>
<script>
import productPrice from 'theme/mixins/productPrice.ts'
import { mapGetters } from 'vuex'

export default {
  name: 'ProductPrice',
  mixins: [productPrice],
  computed: {
    ...mapGetters({
      getBreadcrumbsRoutes: 'breadcrumbs/getBreadcrumbsRoutes'
    }),
    subscribtionPeriod () {
      if (!this.product.editions_qty) return null
      if (this.product.editions_qty === 1) return 'pierwszy miesiąc'
      else if (this.product.editions_qty === 3) return 'pierwszy kwartał'
      else if (this.product.editions_qty === 6) return 'pierwsze pół roku'
      else if (this.product.editions_qty === 12) return 'pierwszy rok'
      else if (this.product.editions_qty === 24) return 'pierwsze 2 lata'
      else return null
    },
    retailPromoText () {
      if (!this.product.editions_qty && !['bundle', 'subscription'].includes(this.product.type_id)) return ''
      if (!this.product.retail_price) return ''
      if (Number(this.product.retail_price) <= 0) return ''
      return this.product.editions_qty
        ? `Cena regularna  za ${this.product.editions_qty} ${this.getFormatTitle(this.product.editions_qty)} to ${this.$options.filters.price(this.product.retail_price)}`
        : `Cena regularna pakietu ${this.$options.filters.price(this.product.retail_price)}`
    }
  },
  methods: {
    getFormatTitle (qty) {
      if (qty % 10 === 1 && (qty > 20 || qty < 10)) {
        return 'tytuł'
      } else if (qty % 10 > 1 && qty % 10 < 5 && (qty > 20 || qty < 10)) {
        return 'tytuły'
      } else {
        return 'tytułów'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
$color-primary: color(primary);
.price-original {
  text-decoration: line-through;
}

.price {
  @media (max-width: 767px) {
    color: $color-primary;
  }
}
.special-price.alternative {
  @media (max-width: 500px) {
    // padding: 15px 15px;
    .row.price > p {
      width: 100%;
    }
    .row.info {
      flex-wrap: wrap !important;
      .h5.cl-burnt-sienna {
        min-width: initial;
        order: -1;
        margin-bottom: 5px;
        margin-left: 0px !important;
      }
    }
  }
  // border: 1px solid #919191;
  // padding: 25px 15px;
  // border-radius: 10px;
  .row.price {
    width: 100%;
    justify-content: space-between;
    align-items: flex-end;
    margin: 0;
  }
  .row.info {
    width: 100%;
    justify-content: space-between;
    align-items: center;
    margin-left: 0;
    margin-right: 0;
    margin-top: 5px;
    flex-wrap: nowrap;
    .h5.cl-burnt-sienna {
      min-width: 190px;
      margin-left: 5px;
    }
  }
}
.promo-book {
  @media (max-width: 767px) {
    margin-left: initial;
    font-size: 14px;
  }
  border-radius: 10px;
  width: fit-content;
  margin-left: auto;
}
.open-omni-chart:hover {
  cursor: pointer;
  text-decoration: underline;
}
</style>
